import {
  Breakpoint,
  Color,
  ContentFilters,
  DownloadBox,
  EmptyPlaceholder,
  FontWeight,
  Markdown,
} from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { MiddleContainerProps } from './knowledgeBaseV2.types';

export const Container = styled.div``;

export const BottomContainer = styled.div`
  background-color: ${Color.Gray100};
  padding: 16px 16px 0;

  @media ${Breakpoint.SmallDesktop} {
    padding: 0 80px;
  }
`;

export const MiddleContainer = styled.div<MiddleContainerProps>`
  border-top: 1px solid ${Color.Gray300};
  padding: 0 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: ${({ $isListViewMode }: MiddleContainerProps): number => $isListViewMode ? 40 : 0}px 80px;
  }
`;

export const StyledContentFilters = styled(ContentFilters)`
  padding: 40px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 56px 80px;
  }
`;

export const StyledMarkdown = styled(Markdown)`
  color: ${Color.Gray700};

  strong {
    color: ${Color.Gray500};
    font-weight: ${FontWeight.Regular};
  }
`;

export const Span = styled.span`
  color: ${Color.Gray500};
`;

export const DownloadBoxWrapper = styled.div``;

export const Separator = styled.div`
  background-color: ${Color.Gray300};
  height: 1px;
  width: 100%;
  margin: 0;

  @media ${Breakpoint.SmallDesktop} {
    margin: 0 40px;
  }
`;

export const StyledDownloadBox = styled(DownloadBox)`
  background-color: ${Color.Gray100};
`;

export const CollapsibleSidePanelCardWrapper = styled.div`
  padding: 20px 0;
  border-top: 1px solid ${Color.Gray300};
  margin: 0;

  @media ${Breakpoint.SmallDesktop} {
    margin: 0 40px;
  }
`;

export const StyledEmptyPlaceholder = styled(EmptyPlaceholder)`
  padding-bottom: 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 80px 0;
  }
`;
